import pkceChallenge from 'react-native-pkce-challenge';
import {
  createAction,
  createAsyncThunk,
  selectMarketingMeta,
  selectMarketingMetaHistory,
  State,
} from '@bonanza-social/toolkit/state';
import { ApiError } from '@bonanza-social/toolkit/api';
import {
  RegistrationData,
  SubmitError,
  SubmitResponse,
} from './registrationForm.types';
import RegistrationService from '../../services/RegistrationService/RegistrationService';
import { mapFormData } from './registrationForm.utils';

export const openSocialRegistrationModal = createAction(
  'socialRegistration/openModal',
);

export const submitSocialRegistrationForm = createAsyncThunk<
  SubmitResponse,
  RegistrationData,
  { rejectValue: SubmitError | ApiError }
>(
  'socialRegistrationForm/submit',
  async (formData, { rejectWithValue, getState }) => {
    const { codeChallenge, codeVerifier } = pkceChallenge();
    const state = getState() as State;
    const marketingMeta = selectMarketingMeta(state);
    const marketingMetaHistory = selectMarketingMetaHistory(state);

    const mappedData = mapFormData(
      formData,
      marketingMeta,
      marketingMetaHistory,
      codeChallenge,
    );

    try {
      const response = await RegistrationService.register({
        data: mappedData,
      });

      const accountData = { ...response, codeVerifier };

      return { account: accountData, formData } as SubmitResponse;
    } catch (error) {
      if (error instanceof ApiError) {
        return rejectWithValue(error);
      }

      throw error;
    }
  },
);
